import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Programmesleft from '../Programmes/ProgrammesleftEle'
import { Container, Row, Col,Table } from 'react-bootstrap';
import LeftPanel from '../Programmes/LeftPanel'


function BtechEle() {
  return (
    <section className="project-detail">
      <Container>
        <Row>
          <Col md={4} className='c-left custom-padding-color mb-4'>            
            <Programmesleft activeIndex={0} />
          </Col>

          <Col md={8} className='c-right'>
             <div className="c-heading">
                <h3>Bachelor of Technology</h3>
              </div>
              <p>
                The following Bachelor of Technology program(s) are being offered at IIT Tirupati:
              </p>


            <Table bordered responsive className='mt-3'>
              <thead>
                <tr>
                  <th>Program</th>
                  <th>Intake</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical Engineering</td>
                  <td>39</td>
                </tr>
                <tr>
                  <td>Civil Engineering</td>
                  <td>39</td>
                </tr>
                <tr>
                  <td>Computer Science and Engineering</td>
                  <td>53</td>
                </tr>
                <tr>
                  <td>Electrical Engineering</td>
                  <td>60</td>
                </tr>
                <tr>
                  <td>Engineering Physics</td>
                  <td>10</td>
                </tr>
                <tr>
                  <td>Mechanical Engineering</td>
                  <td>53</td>
                </tr>
              </tbody>
            </Table>
           {/* <h5 style={{color:'blue'}}> **A B.Tech. program in Engineering Physics in Physics department is being introduced from academic year 2024-25. </h5>
         <p>  For Engineering Physics Curriculum {' '}
              <b>
              <Link to="https://files.iittp.ac.in/pdfs/curriculum/2024/EP_18-3-2024.pdf" target="_blank" rel="noopener noreferrer" className='c-link'>
                  Click here
                </Link>
              </b></p> */}
            <p>
              In all the programs, a credit-based curriculum for 8 semesters will be followed. Each course is evaluated on a 10-point grading system with letter grades. The Cumulative Grade Point Average (CGPA) is calculated at the end of each semester.
            </p>
    
              For more information{' '}
              <b>
              <Link to="/b-tech-admission" target="_blank" rel="noopener noreferrer" className='c-link'>
                  Click here
                </Link>
              </b>
          </Col>
        </Row>
      </Container>

    </section>
  );
}

export default BtechEle;
